export default "__VITE_ASSET__CKfS1ZrT__"